import { AppRouteConfig } from '@/types/routes';

// Helper function to create routes
export const createRoute = (
  path: string | undefined,
  element: React.ReactElement,
  title: string,
  icon?: React.ElementType,
  options?: Partial<AppRouteConfig>
): AppRouteConfig => {
  return {
    path,
    element,
    title,
    icon,
    ...options,
  } as AppRouteConfig;
};
